import {PDFPage} from "@/models/ai/PDFPage";

export interface DocumentDescription {
    pages: PDFPage[];
    documentName:string
}

export class DocumentDescriptionModel implements DocumentDescription {
    pages: PDFPage[];
    documentName:string=""
    constructor(pages: PDFPage[]) {
        this.pages = pages;
    }
}
